import { CarouselProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: CarouselProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as CarouselProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      images: [
        {
          src: 'https://a-static.besthdwallpaper.com/garfield-wallpaper-2800x2100-815_28.jpg',
        },
        {
          src: 'https://m.media-amazon.com/images/M/MV5BZGMwOGIwZjUtOWQ1OS00YWRjLWJmZGMtN2Y1OWQ3ZDYwYTM3XkEyXkFqcGdeQXVyNzU1NzE3NTg@._V1_.jpg',
        },
        {
          src: 'https://a-static.besthdwallpaper.com/cartoons-garfield-wallpaper-1440x1080-6773_22.jpg',
        },
      ],
    } as CarouselProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
